<template>
  <div
    class="color-circle"
    :style="{ background: colorCode }"
    :class="[classForWhiteColor(colorName), { 'unknown-color-circle': colorName === '/' }]"
    :title="colorLabel"
  >
    <span
      v-if="colorName === '/'"
      class="unknown-slash"
    >/</span>
    <span class="color-tooltip">{{ colorLabel }}</span>
  </div>
</template>

<script>
export default {
  name: 'ColorCircle',
  props: {
    colorCode: {
      type: String,
      required: true,
    },
    colorName: {
      type: String,
      default: '',
    },
    colorLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    classForWhiteColor(colorName) {
      if (this.colorCode && this.colorCode.toUpperCase() === '#FFFFFF') return 'white-color-border'
      return colorName && colorName.toLowerCase() === 'white' ? 'white-color-border' : ''
    },
  },
}
</script>

<style scoped lang="scss">
.color-circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #e0e0e0;
  cursor: pointer;

  .color-tooltip {
    position: absolute;
    display: none;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
    }
  }

  &:hover .color-tooltip {
    display: block;
  }
}

.white-color-border {
  border: 1px solid #cccccc;
}

.unknown-color-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;

  .unknown-slash {
    font-size: 10px;
    font-weight: bold;
    color: #666;
    line-height: 1;
  }
}
</style>
